import { InsuranceFields, InsuranceResponse } from "../types";

export const mapInsuranceData = (data: InsuranceResponse) => ({
  [InsuranceFields.APPLICATION_NUMBER]: data.application_id || "",
  [InsuranceFields.INSURANCE_NUMBER]: data.insurance_policy_number || "",
  [InsuranceFields.KIND_OF_INSURANCE]: data.insurance_type || "",
  [InsuranceFields.INSURANCE_COMPANY]: data.insurer_name || "",
  [InsuranceFields.INSURANCE_PREMIUM]: data.premium_amount || "",
  [InsuranceFields.MARINE_SURVEYOR]: data.damage_surveyor || "",
  [InsuranceFields.CURRENCY]: data.currency || "",
});
